/**
 * SIATA Santa Elena local radar — client source constants (Milestone 2).
 * See docs/weather/siata-santa-elena-radar-approval.md
 */

export const SIATA_SANTA_ELENA_RADAR_SOURCE_CODE = "SIATA_SANTA_ELENA";
export const SIATA_SANTA_ELENA_RADAR_SOURCE_KEY = "siata_santa_elena_radar";
export const SIATA_SANTA_ELENA_RADAR_LABEL = "SIATA Santa Elena Radar";
export const SIATA_SANTA_ELENA_RADAR_TRUST_LABEL = "Local official";
export const SIATA_SANTA_ELENA_RADAR_TYPE_LABEL = "Local official radar";
export const SIATA_SANTA_ELENA_RADAR_COVERAGE_LABEL = "Aburrá Valley local coverage";
export const SIATA_SANTA_ELENA_RADAR_ATTRIBUTION =
  "SIATA / Área Metropolitana del Valle de Aburrá";

export const SIATA_SANTA_ELENA_RADAR_FEATURE_FLAG_ENV =
  "REACT_APP_SIATA_SANTA_ELENA_RADAR_ENABLED";

export function isSiataSantaElenaRadarFeatureEnabled() {
  return process.env[SIATA_SANTA_ELENA_RADAR_FEATURE_FLAG_ENV] === "true";
}

export function isSiataSantaElenaRadarPublicUiEnabled() {
  return isSiataSantaElenaRadarFeatureEnabled();
}

export function isSiataSantaElenaRadarWeatherUiVisible() {
  return isSiataSantaElenaRadarPublicUiEnabled();
}

export {
  SIATA_SANTA_ELENA_RADAR_GEOREF,
  SIATA_SANTA_ELENA_RADAR_LAYER_ID,
  SIATA_SANTA_ELENA_RADAR_OVERLAY_CONFIG,
  SIATA_SANTA_ELENA_RADAR_SOURCE_ID,
  getSiataSantaElenaRadarCoordinates,
  isSiataSantaElenaRadarDebugBoundsEnabled,
  isSiataSantaElenaRadarOverlayDebugEnabled,
  resolveSiataSantaElenaRadarBounds,
} from "../components/weather/radar/siataSantaElenaRadarOverlay.js";
